import fetchData from 'src/utils/fetchData';

export const postJoinBySignatureWithPluginAPI = async (data: any) => {
  return fetchData(
    '/ui/front-api/private/organizations/joining-with-signature/join-by-signature-with-plugin',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }
  );
};

export const getDataToSignByPluginAPI = async () => {
  return fetchData(
    '/ui/front-api/private/organizations/joining-with-signature/data-to-sign-by-plugin',
    undefined,
    false
  );
};

export const getDataToSignByExternalSoftwareAPI = async () => {
  return fetchData(
    '/ui/front-api/private/organizations/joining-with-signature/data-to-sign-by-external-software',
    undefined,
    false
  );
};
